<template>
  <div class="modern-form-page">
    <!-- 背景装饰元素 -->
    <div class="background-decoration">
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-blob"></div>
    </div>

    <div class="page-container">
      <div class="form-section">
        <!-- 头部区域 -->
        <div class="form-header">
          <div class="header-icon">
            <i class="el-icon-collection"></i>
          </div>
          <h1 class="form-title">收录申请</h1>
          <p class="form-subtitle">提交您的网站信息，加入服务众包导航</p>
          <div class="header-decoration">
            <div class="decoration-line"></div>
          </div>
        </div>

        <el-form 
          :model="form" 
          :rules="rules" 
          ref="form"
          class="modern-form"
          label-position="top">
          
          <!-- 网站名称 -->
          <el-form-item label="网站名称" prop="name" class="form-item">
            <div class="input-with-action">
              <div class="input-container">
                <i class="el-icon-monitor input-icon"></i>
                <el-input 
                  v-model="form.name"
                  placeholder="请输入网站名称（2-10个字符）"
                  maxlength="10"
                  class="modern-input">
                </el-input>
              </div>
              <el-button 
                class="check-btn"
                @click="clickCx">
                <i class="el-icon-search"></i>
                查询名称
              </el-button>
            </div>
          </el-form-item>

          <!-- 推广网站 -->
          <el-form-item label="推广网站" prop="address" class="form-item">
            <div class="input-container">
              <i class="el-icon-link input-icon"></i>
              <el-input 
                v-model="form.address"
                placeholder="请输入推广网站地址"
                maxlength="100"
                class="modern-input">
              </el-input>
            </div>
          </el-form-item>

          <!-- 联系信息网格 -->
          <div class="form-grid">
            <el-form-item label="QQ号码" prop="qq" class="form-item">
              <div class="input-container">
                <i class="el-icon-qq input-icon"></i>
                <el-input 
                  v-model="form.qq"
                  placeholder="请输入QQ号码"
                  maxlength="15"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="Email" prop="email" class="form-item">
              <div class="input-container">
                <i class="el-icon-message input-icon"></i>
                <el-input 
                  v-model="form.email"
                  placeholder="请输入邮箱地址"
                  maxlength="30"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="联系电话" prop="phone" class="form-item">
              <div class="input-container">
                <i class="el-icon-phone input-icon"></i>
                <el-input 
                  v-model="form.phone"
                  placeholder="请输入电话号码"
                  maxlength="11"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="推荐分类" prop="type" class="form-item">
              <div class="input-container">
                <i class="el-icon-folder-opened input-icon"></i>
                <el-input 
                  v-model="form.type"
                  placeholder="请输入推荐分类"
                  maxlength="30"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="建站时间" prop="time" class="form-item">
              <div class="input-container">
                <i class="el-icon-date input-icon"></i>
                <el-input 
                  v-model="form.time"
                  placeholder="请输入建站时间"
                  maxlength="30"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="日访问量" prop="num" class="form-item">
              <div class="input-container">
                <i class="el-icon-data-analysis input-icon"></i>
                <el-input 
                  v-model="form.num"
                  placeholder="请输入日访问量"
                  maxlength="10"
                  class="modern-input">
                </el-input>
              </div>
            </el-form-item>
          </div>

          <!-- 网站描述 -->
          <el-form-item label="网站描述" prop="synopsis" class="form-item">
            <div class="textarea-container">
              <i class="el-icon-document textarea-icon"></i>
              <el-input
                v-model="form.synopsis"
                type="textarea"
                :rows="4"
                placeholder="请简要描述您的网站特色和服务内容"
                maxlength="100"
                class="modern-textarea">
              </el-input>
            </div>
            <div class="char-count">{{ form.synopsis.length }}/100</div>
          </el-form-item>

          <!-- LOGO上传 -->
          <el-form-item label="上传LOGO" class="form-item">
            <div class="upload-header">
              <i class="el-icon-picture"></i>
              <span>上传LOGO</span>
              <span class="upload-tips">（宽高比例1:1，支持JPG/PNG，最大2MB）</span>
            </div>
            <el-upload
              class="modern-upload"
              action="http://148.70.177.170:8089/uploadManager/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <div class="upload-area" v-if="!form.imageUrl">
                <div class="upload-content">
                  <i class="el-icon-plus upload-icon"></i>
                  <div class="upload-text">点击上传LOGO</div>
                  <div class="upload-subtext">建议尺寸 200×200px</div>
                </div>
              </div>
              <div class="image-preview" v-else>
                <div class="preview-badge">LOGO</div>
                <img :src="form.imageUrl" class="avatar">
                <div class="preview-overlay">
                  <div class="preview-actions">
                    <el-tooltip content="预览" placement="top">
                      <i class="el-icon-zoom-in" @click.stop="previewImage(form.imageUrl)"></i>
                    </el-tooltip>
                    <el-tooltip content="重新上传" placement="top">
                      <i class="el-icon-refresh" @click.stop="form.imageUrl = ''"></i>
                    </el-tooltip>
                  </div>
                  <span>点击重新上传</span>
                </div>
              </div>
            </el-upload>
          </el-form-item>

          <!-- 意见建议 -->
          <el-form-item label="给众包网的意见" class="form-item">
            <div class="textarea-container">
              <i class="el-icon-edit-outline textarea-icon"></i>
              <el-input
                v-model="form.suggestion"
                type="textarea"
                :rows="4"
                placeholder="欢迎提出宝贵意见和建议"
                maxlength="100"
                class="modern-textarea">
              </el-input>
            </div>
            <div class="char-count">{{ form.suggestion.length }}/100</div>
          </el-form-item>

          <!-- 提交按钮 -->
          <div class="submit-section">
            <el-form-item class="form-item">
              <el-button 
                class="submit-btn" 
                @click="submitForm('form')"
                :loading="loading">
                <i class="el-icon-s-promotion"></i>
                {{ loading ? '提交中...' : '提交申请' }}
              </el-button>
            </el-form-item>

            <!-- 返回首页 -->
            <div class="back-home">
              <el-button class="back-btn" @click="goHome">
                <i class="el-icon-house"></i>
                返回首页
              </el-button>
            </div>
          </div>
        </el-form>
      </div>

      <!-- 提示信息侧边栏 -->
      <div class="info-sidebar" v-if="!isMobile">
        <div class="sidebar-content">
          <div class="sidebar-header">
            <i class="el-icon-info"></i>
            <h3 class="info-title">申请提示</h3>
          </div>
          
          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="info-content">
              <strong>优先原则：</strong>
              如果您的网站设置了众包网的文字或图片友情链接，我们将会优先考虑您的收录申请。
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-search"></i>
            </div>
            <div class="info-content">
              <strong>网站名称：</strong>
              输入网站名称后点击"查询"按钮，查看名称是否已被收录。
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-link"></i>
            </div>
            <div class="info-content">
              <strong>友情链接：</strong>
              链接方式有两种，请参考以下代码：
            </div>
          </div>

          <div class="code-example">
            <div class="code-header">文字链接代码：</div>
            <pre class="code-block">{{ wz }}</pre>
            <div class="code-header">图片链接代码：</div>
            <pre class="code-block">{{ wz2 }}</pre>
          </div>

          <div class="logo-example">
            <div class="example-title">众包网LOGO示例</div>
            <div class="logo-container">
              <img src="../../public/home/logo.png" alt="众包网LOGO">
            </div>
          </div>

          <div class="info-item">
            <div class="info-icon">
              <i class="el-icon-folder-opened"></i>
            </div>
            <div class="info-content">
              <strong>推荐分类：</strong>
              如果没有合适分类，请输入"无"，并在给众包网意见备注您期望的分类。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog 
      :visible.sync="previewVisible"
      width="60%"
      top="5vh"
      class="image-preview-dialog">
      <div class="dialog-header" slot="title">
        <i class="el-icon-picture"></i>
        <span>LOGO预览</span>
      </div>
      <div class="dialog-content">
        <img :src="previewImageUrl" class="preview-dialog-image">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { slsq, slyz } from "../api/all.js"

export default {
  name: 'AboutView',
  data() {
    return {
      form: {
        address: '',
        name: '',
        qq: '',
        email: '',
        phone: '',
        type: '',
        time: '',
        num: '',
        synopsis: '',
        suggestion: '',
        imageUrl: ''
      },
      rules: {
        address: [
          { required: true, message: '请输入推广网站', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入网站名称', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        qq: [
          { required: true, message: '请输入QQ号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入Email', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请输入建站时间', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入日访问量', trigger: 'blur' }
        ],
        synopsis: [
          { required: true, message: '请输入网站描述', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入推荐分类', trigger: 'blur' }
        ]
      },
      loading: false,
      wz: '① 文字链接：<a href="http://www.zhongbaowang.org.cn">众包网</a>',
      wz2: '② 图片链接：<a href="http://www.zhongbaowang.org.cn"><img src="http://zhongbapwang.org.cn/img/l0g0.558477ec.png" alt="众包网"/></a>',
      isMobile: null,
      previewVisible: false,
      previewImageUrl: ''
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleAvatarSuccess(res, file) {
      this.form.imageUrl = res.pic
      this.$message.success('LOGO上传成功')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传LOGO图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传LOGO图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewVisible = true
    },
    async clickCx() {
      if (!this.form.name) {
        this.$message.error('请输入网站名称')
        return
      }
      
      try {
        const res = await slyz({ name: this.form.name })
        if (res.status == 1) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error('查询失败，请重试')
      }
    },
    async submitForm(formName) {
      if (!this.form.imageUrl) {
        this.$message.error('请上传网站LOGO')
        return
      }

      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const res = await slsq({
              name: this.form.name,
              network_addr: this.form.address,
              qq: this.form.qq,
              phone: this.form.phone,
              email: this.form.email,
              type: this.form.type,
              create_time: this.form.time,
              network_desc: this.form.synopsis,
              vistor_count: this.form.num,
              network_propose: this.form.suggestion,
              logo_image: this.form.imageUrl
            })
            
            if (res.status == 1) {
              this.$message.success(res.msg)
              this.$refs[formName].resetFields()
              this.form.imageUrl = ''
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            this.$message.error('提交失败，请重试')
          } finally {
            this.loading = false
          }
        }
      })
    },
    goHome() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style scoped lang="less">
.modern-form-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  
  .decoration-circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
  }
  
  .circle-1 {
    width: 300px;
    height: 300px;
    top: -150px;
    right: -100px;
  }
  
  .circle-2 {
    width: 200px;
    height: 200px;
    bottom: -100px;
    left: -50px;
  }
  
  .decoration-blob {
    position: absolute;
    top: 50%;
    right: 10%;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
    animation: morph 15s linear infinite;
  }
}

@keyframes morph {
  0%, 100% { border-radius: 40% 60% 70% 30% / 40% 40% 60% 50%; }
  34% { border-radius: 70% 30% 50% 50% / 30% 30% 70% 70%; }
  67% { border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%; }
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 30px;
  position: relative;
  z-index: 1;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
  
  @media (max-width: 768px) {
    padding: 0;
    gap: 20px;
  }
}

.form-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  padding: 50px;
  
  @media (max-width: 768px) {
    padding: 30px 25px;
    border-radius: 0;
    backdrop-filter: none;
    background: white;
  }
}

.form-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  
  .header-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
    
    i {
      font-size: 32px;
      color: white;
    }
  }
  
  .form-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
  
  .form-subtitle {
    color: #718096;
    font-size: 1.1rem;
    margin: 0;
    font-weight: 400;
  }
  
  .header-decoration {
    margin-top: 30px;
    
    .decoration-line {
      width: 60px;
      height: 4px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      margin: 0 auto;
      border-radius: 2px;
    }
  }
}

.modern-form {
  .form-item {
    margin-bottom: 35px;
    
    /deep/ .el-form-item__label {
      font-weight: 600;
      color: #2d3748;
      margin-bottom: 12px;
      display: block;
      font-size: 15px;
      letter-spacing: 0.5px;
    }
  }
}

/* 输入框容器 */
.input-container,
.textarea-container {
  position: relative;
  
  .input-icon,
  .textarea-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aec0;
    z-index: 2;
    font-size: 18px;
  }
  
  .textarea-icon {
    top: 24px;
    transform: none;
  }
}

.input-with-action {
  display: flex;
  gap: 15px;
  align-items: flex-start;
  
  .input-container {
    flex: 1;
  }
  
  .check-btn {
    height: 56px;
    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
    border: none;
    border-radius: 12px;
    color: white;
    font-weight: 500;
    padding: 0 20px;
    white-space: nowrap;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
    
    i {
      margin-right: 6px;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);
    }
  }
}

.modern-input {
  /deep/ .el-input__inner {
    height: 56px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #f8fafc;
    padding-left: 50px;
    font-size: 15px;
    
    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
      background: white;
    }
    
    &::placeholder {
      color: #a0aec0;
    }
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

.modern-textarea {
  /deep/ .el-textarea__inner {
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #f8fafc;
    resize: vertical;
    min-height: 120px;
    padding: 16px 16px 16px 50px;
    font-size: 15px;
    line-height: 1.5;
    
    &:focus {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
      background: white;
    }
    
    &::placeholder {
      color: #a0aec0;
    }
  }
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #a0aec0;
  margin-top: 8px;
}

/* 上传区域 */
.upload-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  
  i {
    color: #667eea;
    font-size: 20px;
  }
  
  span {
    font-weight: 600;
    color: #2d3748;
    font-size: 15px;
  }
  
  .upload-tips {
    color: #718096;
    font-size: 13px;
    font-weight: normal;
  }
}

.modern-upload {
  /deep/ .el-upload {
    width: 100%;
  }
}

.upload-area {
  border: 2px dashed #cbd5e0;
  border-radius: 16px;
  padding: 40px 20px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  background: #f8fafc;
  
  &:hover {
    border-color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
    
    .upload-icon {
      color: #667eea;
      transform: scale(1.1);
    }
  }
  
  .upload-content {
    .upload-icon {
      font-size: 48px;
      color: #a0aec0;
      margin-bottom: 12px;
      transition: all 0.3s ease;
    }
    
    .upload-text {
      color: #4a5568;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 6px;
    }
    
    .upload-subtext {
      color: #718096;
      font-size: 13px;
    }
  }
}

.image-preview {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
    
    .preview-overlay {
      opacity: 1;
      
      .preview-actions {
        transform: translateY(0);
      }
    }
  }
  
  .preview-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    background: rgba(102, 126, 234, 0.9);
    color: white;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    z-index: 1;
  }
  
  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .preview-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    opacity: 0;
    transition: all 0.3s ease;
    
    .preview-actions {
      display: flex;
      gap: 15px;
      margin-bottom: 10px;
      transform: translateY(10px);
      transition: transform 0.3s ease;
      
      i {
        font-size: 20px;
        cursor: pointer;
        padding: 10px;
        border-radius: 8px;
        background: rgba(255,255,255,0.2);
        transition: all 0.3s ease;
        
        &:hover {
          background: #667eea;
          transform: scale(1.1);
        }
      }
    }
    
    span {
      font-size: 13px;
      opacity: 0.9;
    }
  }
}

/* 提交按钮区域 */
.submit-section {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;
  
  .form-item {
    margin-bottom: 20px;
  }
}

.submit-btn {
  width: 100%;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 16px;
  color: white;
  font-size: 17px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
  position: relative;
  overflow: hidden;
  
  i {
    margin-right: 8px;
    font-size: 18px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.6s;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  &.is-loading {
    background: linear-gradient(135deg, #a3bffa 0%, #b794f4 100%);
  }
}

.back-home {
  text-align: center;
}

.back-btn {
  color: #718096;
  border: 2px solid #e2e8f0;
  background: transparent;
  padding: 12px 30px;
  border-radius: 12px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  i {
    margin-right: 6px;
  }
  
  &:hover {
    border-color: #667eea;
    color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);
  }
}

/* 信息侧边栏 */
.info-sidebar {
  @media (max-width: 1024px) {
    display: none;
  }
}

.sidebar-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  padding: 35px;
  position: sticky;
  top: 100px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  
  i {
    color: #667eea;
    font-size: 24px;
  }
  
  .info-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.info-item {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #edf2f7;
    transform: translateX(5px);
  }
  
  .info-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    i {
      color: white;
      font-size: 16px;
    }
  }
  
  .info-content {
    flex: 1;
    font-size: 14px;
    line-height: 1.6;
    color: #4a5568;
    
    strong {
      color: #2d3748;
      font-weight: 600;
    }
  }
}

.code-example {
  background: #2d3748;
  border-radius: 12px;
  padding: 20px;
  margin: 25px 0;
}

.code-header {
  color: #a0aec0;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.code-block {
  background: #1a202c;
  color: #e2e8f0;
  padding: 15px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.4;
  overflow-x: auto;
  margin-bottom: 15px;
  border-left: 3px solid #667eea;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.logo-example {
  text-align: center;
  margin: 25px 0;
  
  .example-title {
    color: #4a5568;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  
  .logo-container {
    padding: 20px;
    background: #f8fafc;
    border-radius: 12px;
    display: inline-block;
    
    img {
      max-width: 120px;
      height: auto;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }
}

/* 图片预览对话框 */
.image-preview-dialog {
  /deep/ .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  }
  
  /deep/ .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 25px;
    border-bottom: none;
    
    .el-dialog__title {
      color: white;
      font-weight: 600;
    }
    
    .el-dialog__headerbtn {
      top: 20px;
      
      .el-dialog__close {
        color: white;
        font-size: 18px;
        
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
  
  /deep/ .el-dialog__body {
    padding: 0;
    background: #f8fafc;
  }
}

.dialog-header {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  
  i {
    font-size: 20px;
  }
  
  span {
    font-weight: 600;
    font-size: 16px;
  }
}

.dialog-content {
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.preview-dialog-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-section,
.sidebar-content {
  animation: fadeInUp 0.6s ease-out;
}

.form-item {
  animation: fadeInUp 0.6s ease-out;
  animation-fill-mode: both;
}

.form-item:nth-child(1) { animation-delay: 0.1s; }
.form-item:nth-child(2) { animation-delay: 0.2s; }
.form-grid .form-item:nth-child(1) { animation-delay: 0.3s; }
.form-grid .form-item:nth-child(2) { animation-delay: 0.4s; }
.form-grid .form-item:nth-child(3) { animation-delay: 0.5s; }
.form-grid .form-item:nth-child(4) { animation-delay: 0.6s; }
.form-grid .form-item:nth-child(5) { animation-delay: 0.7s; }
.form-grid .form-item:nth-child(6) { animation-delay: 0.8s; }
.form-item:nth-child(4) { animation-delay: 0.9s; }
.form-item:nth-child(5) { animation-delay: 1.0s; }
.form-item:nth-child(6) { animation-delay: 1.1s; }
.submit-section { animation-delay: 1.2s; }

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .modern-form-page {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .input-with-action {
    flex-direction: column;
    
    .check-btn {
      width: 100%;
      height: 50px;
    }
  }
  
  .upload-area {
    padding: 30px 20px;
  }
  
  .image-preview {
    width: 150px;
    height: 150px;
    margin: 0 auto;
  }
  
  .submit-btn {
    height: 55px;
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .form-header .header-icon {
    width: 60px;
    height: 60px;
    
    i {
      font-size: 24px;
    }
  }
  
  .form-title {
    font-size: 1.8rem !important;
  }
}
</style>